import {
  GET_ACCTAG,
  GET_ACCTAG_SUCCESS,
  GET_ACCTAG_FAIL,
  DELETE_ACCTAG,
  DELETE_ACCTAG_SUCCESS,
  DELETE_ACCTAG_FAIL,
  UPDATE_ACCTAG,
  UPDATE_ACCTAG_SUCCESS,
  UPDATE_ACCTAG_FAIL,
  ADD_NEW_ACCTAG,
  ADD_ACCTAG_SUCCESS,
  ADD_ACCTAG_FAIL,
  ACCTAG_LOADING,
} from "./actionType";

export const getAccTagSuccess = (actionType, data) => ({
  type: GET_ACCTAG_SUCCESS,
  payload: { actionType, data },
});

export const getAccTagFail = (actionType, error) => ({
  type: GET_ACCTAG_FAIL,
  payload: { actionType, error },
});

export const getAccTag = data => ({
  type: GET_ACCTAG,
  payload: data,
});

export const getAccTagLoading = () => ({
  type: ACCTAG_LOADING
});

export const deleteAccTag = data => ({
  type: DELETE_ACCTAG,
  payload: data,
});

export const deleteAccTagSuccess = data => ({
  type: DELETE_ACCTAG_SUCCESS,
  payload: data,
});

export const deleteAccTagFail = error => ({
  type: DELETE_ACCTAG_FAIL,
  payload: error,
});

export const updateAccTag = data => ({
  type: UPDATE_ACCTAG,
  payload: data,
});

export const updateAccTagFail = error => ({
  type: UPDATE_ACCTAG_FAIL,
  payload: error,
});

export const updateAccTagSuccess = data => ({
  type: UPDATE_ACCTAG_SUCCESS,
  payload: data,
});

export const addNewAccTag = data => ({
  type: ADD_NEW_ACCTAG,
  payload: data,
});

export const addAccTagSuccess = data => ({
  type: ADD_ACCTAG_SUCCESS,
  payload: data,
});

export const addAccTagFail = error => ({
  type: ADD_ACCTAG_FAIL,
  payload: error,
});